module.exports = __webpack_public_path__ + "src/img/artist/indexpic05.jpg?733ff2c7774aad1eb554a78495c2d9db";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic05.jpg
// module id = 132
// module chunks = 0